import { render } from "./AuthNavbar.vue?vue&type=template&id=54e4627e"
import script from "./AuthNavbar.vue?vue&type=script&lang=js"
export * from "./AuthNavbar.vue?vue&type=script&lang=js"

import exportComponent from "/root/projects/website/vue-notus-main/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__